import React from "react";
import { useEffect } from "react";
import "aos/dist/aos.css"; // Import the AOS styles
import AOS from "aos";

export default function Work() {
  useEffect(() => {
    AOS.init(); // Initialize AOS
    AOS.refresh(); // Refresh AOS to detect new elements

    return () => {
      AOS.refreshHard(); // Cleanup AOS on component unmount
    };
  }, []);

  const CreateProjectCard = ({
    imageSRC,
    heading,
    description,
    techStack,
    colorName,
    liveLink,
    codeSource,
    isTrue = false,
    title_1 = "Go Live",
    title_2 = "Code Source",
  }) => {
    return (
      <>
        <div
          data-aos="zoom-in-up"
          className="h-[600px] inset-20 shadow-[rgba(0,0,15,0.5)_10px_5px_4px_0px] p-5 grid grid-cols-1 items-baseline justify-center ts:w-11/12 lg:w-10/12 font-space m-auto bg-gray-light rounded-md hover:shadow-xl dark:bg-[#7793c2]"
        >
          <div className="h-[150px] w-full">
            <img
              src={imageSRC}
              alt="project-src"
              className="object-cover h-full w-full"
            />
          </div>

          <h2 className="font-bold text-lg underline h-fit text-common-red dark:text-red-800">
            {heading}
          </h2>
          <p className="text-base justify-start">{description}</p>
          <p className="self-end font-semibold">
            <span className="text-common-red font-medium text-lg dark:text-red-800">
              Tech Stack:{" "}
            </span>
            {techStack}
          </p>

          <div className="flex gap-1 w-full justify-around self-end">
            {isTrue ? (
              <i className={`fa-solid fa-video ${colorName}`}></i>
            ) : null}

            <a
              href={liveLink}
              target="_blank"
              rel="noopener noreferrer"
              title={title_1}
            >
              <i
                className={`fa-solid fa-rocket text-3xl ${colorName} hover:text-common-red transform transition-transform duration-700 ease-in-out hover:scale-125`}
              ></i>
            </a>
            <a
              href={codeSource}
              target="_blank"
              rel="noopener noreferrer"
              title={title_2}
            >
              <i
                className={`fa-brands fa-github text-3xl ${colorName} hover:text-common-red transform transition-transform duration-700 ease-in-out hover:scale-125`}
              ></i>
            </a>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <div
        className="grid justify-center vs:py-20 ts:p-4 md:p-8 dark:bg-[#1e386b] "
        id="PROJECTS"
      >
        <h1 className="text-center pb-20 vs:text-2xl ts:text-4xl font-Ubuntu font-bold dark:text-white">
          My Creative{" "}
          <span className="text-common-red border-b-4 border-common-red">
            Portfolio
          </span>{" "}
          Section
        </h1>
        <div className="grid vs:grid-cols-1 ts:grid-cols-2 lg:grid-cols-3 gap-3  gap-y-5 justify-center vs:px-8 md:px-24">
          <CreateProjectCard
            imageSRC="Images/framedForever.png"
            heading="Framed Forever"
            description="A full-stack photography website designed to showcase a photographer’s work, manage events/galleries, and enable client bookings. The platform includes a powerful admin panel for complete control over content, bookings, and landing page customization."
            techStack="NextJS, Redux, Tailwind CSS, Node.js, Express, MongoDB, Mongoose, Cloudinary"
            colorName="white"
            liveLink="https://framedforever.vercel.app/"
            codeSource="https://github.com/maahin2005"
            title_2="Private Repo"
          />
          <CreateProjectCard
            imageSRC="Images/sears.jpg"
            heading="Sears e-commerce Clone! "
            description="This Project is a Full Stack MERN application that replicates the Sears.com e-commerce website. It features user authentication, product management, shopping cart functionality, and responsive design."
            techStack=" ReactJS, Redux, Tailwind CSS, Daisy UI, Node.js, Express, MongoDB, Mongoose"
            colorName="white"
            liveLink="https://sears-clone-com.vercel.app/"
            codeSource="https://github.com/maahin2005/sears-app"
          />
          <CreateProjectCard
            imageSRC="Images/TaskManagement.jpg"
            heading="Task Management System"
            description="Developed a comprehensive Task Management System featuring user authentication, full CRUD operations for tasks, and advanced categorization based on task status and priority."
            techStack="Next.js, TypeScript, Clerk (authentication), Prisma, Mongoose"
            colorName="white"
            liveLink="https://tasksmanagementapplication.vercel.app/"
            codeSource="https://github.com/maahin2005/Task_Manager"
          />
          <CreateProjectCard
            imageSRC="Images/space-blogs.jpg"
            heading="Space-themed Blog Website"
            description="Developed during constructor week, this project features a visually stunning blog website with a captivating space theme. it showcases my front-end development skills. Integrated Sanity CMS for easy content management."
            techStack="React, Chakra-ui, Sanity"
            colorName="white"
            liveLink="https://space-sparkles.vercel.app/"
            codeSource="https://github.com/maahin2005/space-blog"
          />

          <CreateProjectCard
            imageSRC="Images/Learning-node-experts.jpg"
            heading="Learning-Exp Assignment"
            description="Completed within a tight 24-hour deadline, this project involved adding functionality to a provided UI for a learning-exp platform. Despite the time constraints, I successfully implemented the required features, showcasing my ability to deliver quality work under pressure."
            techStack="React, Chakra-ui"
            colorName="white"
            liveLink="https://learning-landing-page.netlify.app/"
            codeSource="https://github.com/maahin2005/Learning-Landing-Page"
          />
          <CreateProjectCard
            imageSRC="Images/Interview-IQ-HUB.jpg"
            heading="Interview IQ Hub"
            description="Collaborating with a backend developer, I handled the frontend, a full-stack project. Users fill out a form detailing their skills, and based on this skills, the platform arranges a tailored assessment. We also implemented an admin panel, enhancing the platform's functionality."
            techStack="React, chakra-ui"
            colorName="white"
            liveLink="https://fe-interviewiq-hub.netlify.app/"
            codeSource="https://github.com/akmurmu82/InterviewIQ-Hub/tree/main/front-end"
            title_2="Private Repo"
          />
          <CreateProjectCard
            imageSRC="Images/JIO-MART-replica.jpg"
            heading="JioMart Replica!🛒🌟"
            description="JioMart replica with some the bells and whistles! From seamless navigation to adding products to the cart, signing in/out, and placing orders, every feature is designed to enhance the shopping experience."
            techStack="React, Chakra-ui"
            colorName="white"
            liveLink="https://jio-mart-replica.vercel.app/"
            codeSource="https://github.com/maahin2005/Jio-Mart-Replica"
          />

          <CreateProjectCard
            imageSRC="Images/flipkart.jpg"
            heading="Flipkart UI Clone"
            description="This project is a replica of the popular e-commerce website Flipkart, built using React, Chakra UI, and react-slick. I have completed this project within 24 hours strict deadline!"
            techStack=" React, Chakra UI"
            colorName="white"
            liveLink="https://flipkart-com.vercel.app/"
            codeSource="https://github.com/maahin2005/Flipkart-Replica"
          />
          {/* <CreateProjectCard
            imageSRC="Images/Song.jpg"
            heading="Song Time"
            description="Explore 'Songs Anywhere' in my portfolio—a minimalist music app showcasing my web development skills. Curated songs, sleek design, and streamlined functionality for an effortless music experience"
            techStack=" HTML, CSS, JavaScript"
            colorName="white"
            liveLink="https://songs-anywhere-bymahin.vercel.app/"
            codeSource="https://github.com/maahin2005/Songs_AnyWhere"
          /> */}

          {/* <CreateProjectCard
            imageSRC="Images/Movies_search.jpeg"
            heading="Movies Search Bar"
            description="Enhanced website usability with a smart movie search bar, offering Google-style autocomplete suggestions. Users can effortlessly discover and click on movies, streamlining the search experience."
            techStack=" HTML, CSS, JavaScript"
            colorName="white"
            liveLink="https://movies-website-search-bymahin.netlify.app/"
            codeSource="https://github.com/maahin2005/Movie_Search_Project"
          /> */}

          <CreateProjectCard
            imageSRC="Images/Milaap.jpeg"
            heading="Milaap.org Replica"
            description="I had the opportunity to recreate the Milaap website as part of my portfolio. 🌐 With this clone, I aimed to replicate the user interface and functionality of the Milaap website, showcasing my skills in frontend development."
            techStack=" HTML, CSS, JavaScript"
            colorName="white"
            liveLink="https://milaaporg-by-mahin.netlify.app/"
            codeSource="https://github.com/maahin2005/milaap-org-project"
          />
          {/* <CreateProjectCard
            imageSRC="Images/Movie_site.jpeg"
            heading="Movies Details"
            description="Built a sleek movie information website for quick and comprehensive film searches, providing users with a seamless and efficient platform for accessing details on their favorite movies."
            techStack=" HTML, CSS, JavaScript"
            colorName="white"
            liveLink="https://movies-website-maahin2005.vercel.app/"
            codeSource="https://github.com/maahin2005/Movies-Website"
          /> */}
          {/* <CreateProjectCard
            imageSRC="Images/Study_app.jpeg"
            heading="Study Time"
            description="I've built a user-friendly website offering quick access to essential study materials in PDF format, streamlining the learning process. Explore it for a glimpse into simplified studying."
            techStack=" React, BootStrap"
            colorName="white"
            liveLink="https://maahi-sciencehub0786.vercel.app/"
            codeSource="https://github.com/maahin2005/Maahi_ScienceHub"
            title_2="Private Repo"
          /> */}
        </div>
      </div>
    </>
  );
}
